module.exports = __webpack_public_path__ + "img/fivewe.c73e07d4.png";